import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from '@rocketlane/rocket-router';
import { ROUTE_PATHS } from '../routes-paths';
/**
 * Canonical RM Agent chat lives at /resource-management/copilot.
 * /agents/rm is the desktop sidebar entry URL (and a short alias).
 */ export const agentsRmRoute = {
    path: 'agents/rm',
    element: /*#__PURE__*/ _jsx(Navigate, {
        to: `/${ROUTE_PATHS.RESOURCE_MANAGEMENT}/${ROUTE_PATHS.RM_COPILOT}`,
        replace: true
    })
};
